import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  successModal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "40px",
  },
  tickIcon: {
    width: "48px",
    height: "48px",
  },
  successMsg: {
    fontSize: "20px",
    fontWeight: 600,
    fontFamily: "Roboto",
    lineHeight: "100%",
    color: "#444444",
    textAlign: "center",
  },
}));
